import React from 'react';
import { debounce } from 'lodash/fp';
import classNames from 'classnames';
import request from 'utils/request_ajax';
import { Icon } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

class NewQuestionField extends React.Component {
  constructor(props) {
    super(props);
    this.update = debounce(300, this.update.bind(this));
    this.destroy = this.destroy.bind(this);
  }

  update() {
    request
      .put(this.props.data.update_path, { title: this.input.value })
      .then(payload => {
        if (payload.success) {
          this.props.onUpdate(payload.question_field);
        }
      });
  }

  destroy() {
    this.props.onDelete(this.props.data);
  }

  render() {
    const { i18n, isDuplicate, data } = this.props;
    const containerStyles = classNames('mb-12 ai-c', {
      'd-f': !isDuplicate,
    });
    const inputStyles = classNames('QuestionField--new bdrs-2', {
      'QuestionField--duplicate': isDuplicate,
    });

    return (
      <div className={containerStyles}>
        <Text
          variant={TEXT_VARIANTS.SUBHEADER_BOLD}
          component="input"
          defaultValue={data.title ? data.title : ''}
          ref={input => {
            this.input = input;
          }}
          className={inputStyles}
          onChange={this.update}
          placeholder={t(
            'questions.question.ticket_handling.lesson_builder.secondary_fields.placeholder',
          )}
        />
        <Icon name="remove" onClick={this.destroy} className="c-p ml-8" />
        {isDuplicate && (
          <div className="c-brand-red mt-4">
            {i18n.lesson_builder.secondary_fields.duplication_warning}
          </div>
        )}
      </div>
    );
  }
}

export default NewQuestionField;
